import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useCookies } from "react-cookie";
import { Flex } from "uikit-react";
import moment from "moment";

import Pagination from "../../common/Pagination";
import RecordsPerPage from "../../common/RecordsPerPage";
import { AppContexts } from "../../../providers";

import FilterPanel from "../Common/FilterPanel";
import usePath from "../Common/History";

const FiveStarRating = () => {
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const { active, fivestar, startDate, endDate, getFiveStar } = useContext(
    AppContexts.ReportsContext
  );

  const path = usePath();
  const { total, paginated } = fivestar;

  useEffect(() => {
    if (path !== active) setPage(0);
  }, [path]);

  useEffect(() => {
    if (active === "fivestar-rating") getFn(startDate, endDate);
  }, [page, filter, recordsPerPage]);

  const getFn = useCallback(
    (start, end) => {
      if (!start || !end) {
        return;
      } else {
        getFiveStar(
          start,
          end,
          page,
          recordsPerPage,
          filter ? filter.trim() : filter
        );
      }
    },
    [page, filter, recordsPerPage]
  );

  const handlePageChange = useCallback((page) => setPage(page), []);
  const handleFilterChange = useCallback((filter) => setFilter(filter), []);

  return (
    <li className="reports-tab-content">
      <h2>Five Star Ratings</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <FilterPanel
          searchTermPlaceholder="Guest Name Or Property ID"
          onFilterChange={handleFilterChange}
          onSubmit={getFn}
        />
        <table className="uk-table uk-table-hover uk-table-divider hms-table uk-margin-small-top">
          <thead>
            <tr>
              <th>RATED ON</th>
              <th>GUEST NAME</th>
              <th>CHECK-IN DATE</th>
              <th>PROPERTY ID</th>
              <th>RATING</th>
            </tr>
          </thead>
          <tbody>
            {paginated?.length ? (
              paginated?.map((item) => (
                <tr>
                  <td>
                    {moment.utc(item.rated_on).local().format("MM/DD/YYYY hh:mm a")}
                  </td>
                  <td>{item.guest_name}</td>
                  <td>{moment.utc(item.check_in).format("MM/DD/YYYY")}</td>
                  <td className="reports-table-wrap-overflow">{item.pms_id}</td>
                  <td>
                    <div className="uk-flex uk-flex-between uk-flex-top">
                      <div className="hms-guest-review">
                        {[...Array(Math.round(item.response))].map(
                          (value, idx) => (
                            <span
                              key={`rating_${idx}`}
                              uk-icon="icon: star; ratio: 0.8"
                              className="hms-rated-star"
                            ></span>
                          )
                        )}
                        {[...Array(5 - Math.round(item.response))].map(
                          (value, idx) => (
                            <span
                              key={`non-rating_${idx}`}
                              uk-icon="icon: star; ratio: 0.8"
                            ></span>
                          )
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="no-results">
                  No results for this date range
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination
          count={total}
          index={page}
          onIndexChanged={handlePageChange}
        />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default FiveStarRating;
